/* ControlZ - GST invoice option in cart (page + drawer).
   Loaded once from layout/theme.liquid. Uses event delegation so it keeps
   working after the cart drawer re-renders. Markup lives in snippets/cz-gst-block.liquid. */
(function () {
  if (window.__czGstLoaded) return;
  window.__czGstLoaded = true;

  var CODE = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var FMT = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  var state = { dirty: false, saved: null };

  function valid(s) {
    if (!FMT.test(s)) return false;
    var st = parseInt(s.slice(0, 2), 10);
    if (!((st >= 1 && st <= 38) || st === 97 || st === 99)) return false;
    var sum = 0;
    for (var i = 0; i < 14; i++) {
      var p = CODE.indexOf(s[i]) * (i % 2 === 0 ? 1 : 2);
      sum += Math.floor(p / 36) + (p % 36);
    }
    return CODE[(36 - (sum % 36)) % 36] === s[14];
  }

  function q(root, c) { return root.querySelector('.' + c); }
  function roots() { return Array.prototype.slice.call(document.querySelectorAll('.cz-gst')); }

  function read(root) {
    return {
      on: q(root, 'cz-gst-on').checked,
      num: q(root, 'cz-gst-num').value.toUpperCase().trim(),
      nm: q(root, 'cz-gst-name').value.trim(),
      ad: q(root, 'cz-gst-addr').value.trim()
    };
  }

  function setOpen(root, on) {
    var fields = q(root, 'cz-gst__fields');
    fields.hidden = !on;
    Array.prototype.forEach.call(fields.querySelectorAll('input,textarea'), function (el) { el.disabled = !on; });
  }

  function check(root) {
    var d = read(root), msg = q(root, 'cz-gst__msg');
    function say(t, c) { msg.textContent = t || ''; msg.className = 'cz-gst__msg ' + (c || ''); }
    if (!d.on) { say(''); return true; }
    if (!d.num) { say('Enter your GSTIN to receive a GST invoice.', 'err'); return false; }
    if (!valid(d.num)) { say('That GSTIN doesn\u2019t look valid \u2014 please re-check.', 'err'); return false; }
    if (!d.nm) { say('Add the registered business name.', 'err'); return false; }
    say('GSTIN verified.', 'ok');
    return true;
  }

  function sync(root) {
    var d = read(root);
    roots().forEach(function (r) {
      if (r === root) return;
      q(r, 'cz-gst-on').checked = d.on;
      q(r, 'cz-gst-num').value = d.num;
      q(r, 'cz-gst-name').value = d.nm;
      q(r, 'cz-gst-addr').value = d.ad;
      setOpen(r, d.on);
    });
    state.dirty = false;
    state.saved = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'GST Invoice': d.on ? 'Yes' : '',
        'GSTIN': d.on ? d.num : '',
        'Legal Business Name': d.on ? d.nm : '',
        'Registered Address': d.on ? d.ad : ''
      } })
    }).catch(function () {});
    return state.saved;
  }

  function gstRoot(el) { return el && el.closest ? el.closest('.cz-gst') : null; }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('cz-gst-on')) return;
    var root = gstRoot(t);
    setOpen(root, t.checked);
    check(root);
    sync(root);
  });

  document.addEventListener('input', function (e) {
    var root = gstRoot(e.target);
    if (!root || e.target.classList.contains('cz-gst-on')) return;
    state.dirty = true;
  });

  document.addEventListener('focusout', function (e) {
    var root = gstRoot(e.target);
    if (!root || e.target.classList.contains('cz-gst-on')) return;
    if (check(root) && state.dirty) sync(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[name="checkout"]') : null;
    if (!btn) return;
    var scope = btn.closest('cart-drawer') || btn.closest('.cart-order') || document;
    var root = scope.querySelector('.cz-gst') || document.querySelector('.cz-gst');
    if (!root || !q(root, 'cz-gst-on').checked) return;
    if (!check(root)) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      q(root, 'cz-gst-num').focus();
      return;
    }
    if (state.dirty || !state.saved) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      sync(root).then(function () { btn.click(); });
    }
  }, true);
})();
